import { render } from "./mygoodorderDesc.vue?vue&type=template&id=213cf4f7&scoped=true"
import script from "./mygoodorderDesc.vue?vue&type=script&lang=js"
export * from "./mygoodorderDesc.vue?vue&type=script&lang=js"

import "./mygoodorderDesc.vue?vue&type=style&index=0&id=213cf4f7&lang=scss"
import "./mygoodorderDesc.vue?vue&type=style&index=1&id=213cf4f7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213cf4f7"]])

export default __exports__